import type { DiagnosticGoal } from 'shared/types'
import { client } from '../clients'

const getMany = () => client.get<DiagnosticGoal[]>('/diagnosticGoals/all')

export const goals = {
  getMany
}
